import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import VolatileLoginForm, { ILoginFormProps } from './VolatileLoginForm'

interface ILoginDialogProps extends ILoginFormProps {
  show: boolean
}

const LoginDialog: React.FC<ILoginDialogProps> = ({ show, onClose, ...authFunction }) => {
  const [isRegister, setIsRegister] = useState(false)

  useEffect(() => {
    setIsRegister(false)
  }, [show])

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{isRegister ? <>Регистрация</> : <>Вход</>}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <VolatileLoginForm
          onClose={onClose}
          onIsRegistration={setIsRegister}
          {...authFunction}
        />
      </Modal.Body>
    </Modal>
  )
}
export default LoginDialog
